import { Box, Button, Fade } from "@material-ui/core";
import React from "react";
import useCountry from "../../../hooks/use-country";
import { useStoreLocatorAddressSelector } from "../../../hooks/use-store-locator-address";
import useSubcountry from "../../../hooks/use-subcountry";
import useTranslate from "../../../hooks/use-translate";

type Props = {
  onClick: () => void;
};

export default function AddressConfirmButton({ onClick }: Props) {
  const t = useTranslate();

  const country = useCountry();
  const { subcountry, setSubcountry } = useSubcountry();

  const address = useStoreLocatorAddressSelector(c => c.address);
  const addressMatchingCountry = useStoreLocatorAddressSelector(
    c => c.addressMatchingCountry
  );
  const addressMatchingSubcountry = useStoreLocatorAddressSelector(
    c => c.addressMatchingSubcountry
  );

  const isAddressMatchingCurrentWebsite =
    country === addressMatchingCountry &&
    subcountry === addressMatchingSubcountry;

  if (!address || !isAddressMatchingCurrentWebsite) {
    return null;
  }

  return (
    <Fade in timeout={250}>
      <Box mt={2}>
        <Button variant="contained" color="primary" fullWidth onClick={onClick}>
          {t("expressDelivery.useAddress")}
        </Button>
      </Box>
    </Fade>
  );
}
